import React, { useState } from "react";
import logo from "../Assets/Website Logo 1.png";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <img
          onClick={() => window.location.href = '/'}
          src={logo}
          alt="Homeeera Logo"
          className="logo-img"
        />
      </div>
      <button
        className={`hamburger${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen((open) => !open)}
        aria-label="Toggle navigation menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <ul className={`nav-links${menuOpen ? " show" : ""}`}>
        <li>
          <a href="/" onClick={() => setMenuOpen(false)}>
            Our Vision
          </a>
        </li>
        <li>
          <a href="/" onClick={() => setMenuOpen(false)}>
            Platforms
          </a>
        </li>
        <li>
          <a href="/connect" onClick={() => setMenuOpen(false)}>
            Connect Us
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;